import * as React from 'react';
import moment from 'moment';
import Chip from '@mui/material/Chip';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import { Translate } from '../../../../../shared/LanguageService';
import { LocalDateTime } from '../../../../localDate/DateTimeView';

export type CustomerApprovalState = 'none' | 'awaiting' | 'approved';

type CustomerApprovalIndicatorProps = {
    photoStatus: {
        customerApproval?: CustomerApprovalState;
        customerApprovalDate?: LocalDateTime | null;
    };
};

const translationPrefix = 'image-processing/page/order-row/header/customer-approval';

export function CustomerApprovalIndicator({ photoStatus }: CustomerApprovalIndicatorProps) {
    if (photoStatus.customerApproval === 'approved' && photoStatus.customerApprovalDate) {
        return (
            <Chip
                size="small"
                color="success"
                icon={<CheckCircleIcon />}
                label={Translate(`${translationPrefix}/approved`, {
                    date: moment(photoStatus.customerApprovalDate.localDateTime).format('L')
                })}
            />
        );
    }

    if (photoStatus.customerApproval === 'awaiting') {
        return (
            <Chip
                size="small"
                variant="outlined"
                icon={<HourglassEmptyIcon />}
                label={Translate(`${translationPrefix}/awaiting`)}
            />
        );
    }

    return null;
}
